import Immutable from 'immutable';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Icon, Input } from 'semantic-ui-react';

import { addModifiers } from '../../../shared/helpers';
import { formatMessageHelper } from '../../../shared/helpers/internationalization';
import ErrorMsgIntl from '../ErrorMsg/ErrorMsgIntl';

import { usePasswordVisibility } from './usePasswordVisibility';

import './PasswordInput.scss';

export interface PasswordInputProps {
  id?: string;
  name: string;
  value?: string;
  onChange?: (event: any, data: any) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  modifiers?: string[];
  placeholder?: string;
  autoFocus?: boolean;
  autoComplete?: string;
  tabIndex?: number;
  disabled?: boolean;
  required?: boolean;
  errors?: Immutable.List<string>;
}

const PasswordInputComponent: React.FC<PasswordInputProps & InjectedIntlProps> = ({
  id,
  name,
  value,
  onChange,
  onBlur,
  onKeyUp,
  className,
  modifiers = [],
  placeholder = '',
  autoFocus,
  autoComplete,
  tabIndex,
  disabled,
  required,
  errors,
  intl,
}) => {
  const { type, visible, toggle, iconName } = usePasswordVisibility();
  const toggleLabel = formatMessageHelper(intl, visible ? 'password.hide' : 'password.show');
  const inputErrors = errors ?? Immutable.List<string>([]);

  return (
    <div className={addModifiers('password-input', modifiers)}>
      <div className="password-input__content-input">
        <Input
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyUp={onKeyUp}
          className={['password-input__input', className].filter(Boolean).join(' ')}
          placeholder={placeholder}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          tabIndex={tabIndex}
          disabled={disabled}
          required={required}
        />
        <button type="button" className="password-input__visibility" onClick={toggle} aria-label={toggleLabel} aria-pressed={visible}>
          <Icon name={iconName} fitted />
        </button>
      </div>
      {inputErrors.size !== 0 && (
        <div className="input__error">
          <ErrorMsgIntl errors={inputErrors} />
        </div>
      )}
    </div>
  );
};

export const PasswordInput = injectIntl(PasswordInputComponent);
export default PasswordInput;
